const documentPreview = {
  actions: {
    download: 'Descargar',
    close: 'Cerrar',
  },
};

export default documentPreview;
